import {Utils} from "@/common/utils";
import useSWR from "swr";
import {PostscriptNotification} from "Stores/superStore";
import { StandardResponse } from "@/types/swr";

const clientConfigs = Utils.getEAIClientConfigs();

export function useNotifications() {
    const {data, error, mutate} = useSWR<StandardResponse<PostscriptNotification>, Error>(`${clientConfigs.baseUrl}/notifications/`);

    return {
        data: data?.data,
        error,
        mutate
    };
}
